var productRemember = document.getElementById('product-remember-checkbox');

if (productRemember) {
    var request = new XMLHttpRequest();

    request.onreadystatechange = function() {
        if(request.readyState === 4) {
            if(request.status !== 200) {
                //TODO: show error ??
            }
        }
    };

    productRemember.addEventListener('click', onProductRememberClick);
}

function onProductRememberClick() {
    var type = 'DELETE';
    var url = this.getAttribute('data-remove-url');

    if (this.checked) {
        type = 'POST';
        url = this.getAttribute('data-add-url');
    }

    request.open(type, url);
    request.setRequestHeader('Content-Type', 'application/json');
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    request.send();
}
